/**
 * Feature codes for the feature gating system.
 * These codes must match the backend FeatureCodes constants.
 */
export const FeatureCodes = {
	// Organization features
	ORGANIZATION_SEND_MESSAGES: 'ORGANIZATION_SEND_MESSAGES',
	ORGANIZATION_AI_SEARCH: 'ORGANIZATION_AI_SEARCH',
	ORGANIZATION_SAVED_SEARCHES: 'ORGANIZATION_SAVED_SEARCHES',
	ORGANIZATION_CONTRACTS: 'ORGANIZATION_CONTRACTS',
	ORGANIZATION_QUOTES: 'ORGANIZATION_QUOTES',

	// Talent features
	TALENT_ACCEPT_CONTRACTS: 'TALENT_ACCEPT_CONTRACTS',
	TALENT_PROFILE_BOOST: 'TALENT_PROFILE_BOOST',
	TALENT_QUOTES: 'TALENT_QUOTES',
} as const;

export type FeatureCode = (typeof FeatureCodes)[keyof typeof FeatureCodes];

/**
 * Feature types
 */
export type FeatureType = 'boolean' | 'limit';

/**
 * Plan types matching backend SubscriptionPlanTypes
 */
export const PlanTypes = {
	// Organization plans
	ORGANIZATION_FREE: 'ORGANIZATION_FREE',
	ORGANIZATION_PLUS: 'ORGANIZATION_PLUS',
	ORGANIZATION_PRO: 'ORGANIZATION_PRO',

	// Talent plans
	TALENT_FREE: 'TALENT_FREE',
	TALENT_PLUS: 'TALENT_PLUS',
	TALENT_PRO: 'TALENT_PRO',
} as const;

export type PlanType = (typeof PlanTypes)[keyof typeof PlanTypes];

/**
 * Feature display names for UI
 */
export const FeatureNames: Record<FeatureCode, string> = {
	ORGANIZATION_SEND_MESSAGES: 'Send Messages',
	ORGANIZATION_AI_SEARCH: 'AI Search',
	ORGANIZATION_SAVED_SEARCHES: 'Saved Searches',
	ORGANIZATION_CONTRACTS: 'Contracts',
	ORGANIZATION_QUOTES: 'Quotes',
	TALENT_ACCEPT_CONTRACTS: 'Accept Contracts',
	TALENT_PROFILE_BOOST: 'Profile Boost',
	TALENT_QUOTES: 'Quotes',
};
